/* LitLamps: switch gallery image to the selected variant's featured media.
   Covers product pages, quick-add modals, Kaching and #litlamp-lls pickers. */
(function(){
  'use strict';
  var cache = {};
  function roots(){ return document.querySelectorAll('[id^="MainProduct-"], quick-add-modal [id^="QuickAddInfo-"]'); }
  function productUrl(root){
    var el = root.querySelector('variant-selects[data-url], product-info[data-url], [data-url^="/products/"]');
    var u = el && el.dataset.url;
    if (!u || u.indexOf('/products/') === -1) {
      if (root.closest('quick-add-modal')) return null;
      u = location.pathname;
    }
    return u.split('?')[0].replace(/\/$/, '');
  }
  function inlineVariants(root){
    var s = root.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch(e){ return null; }
  }
  function productJson(root){
    var u = productUrl(root); if (!u) return Promise.resolve(null);
    if (!cache[u]) cache[u] = fetch(u + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    return cache[u];
  }
  function currentId(root){
    var i = root.querySelector('form[action*="/cart/add"]:not([id*="installment"]) [name="id"]');
    return i ? String(i.value) : '';
  }
  function findVariant(list, id){ if (!list) return null; for (var k=0;k<list.length;k++) if (String(list[k].id)===String(id)) return list[k]; return null; }
  function firstImg(gallery){ return gallery.querySelector('li[data-media-id] img'); }
  function remember(gallery){
    var img = firstImg(gallery); if (!img || img.dataset.llOrigSrc) return img;
    img.dataset.llOrigSrc = img.getAttribute('src') || '';
    img.dataset.llOrigSrcset = img.getAttribute('srcset') || '';
    img.dataset.llOrigSizes = img.getAttribute('sizes') || '';
    return img;
  }
  function restore(gallery){
    var img = firstImg(gallery); if (!img || !img.dataset.llOrigSrc) return;
    if (img.dataset.llSwapped !== '1') return;
    img.setAttribute('src', img.dataset.llOrigSrc);
    if (img.dataset.llOrigSrcset) img.setAttribute('srcset', img.dataset.llOrigSrcset); else img.removeAttribute('srcset');
    if (img.dataset.llOrigSizes) img.setAttribute('sizes', img.dataset.llOrigSizes);
    img.dataset.llSwapped = '0';
  }
  function activate(root, gallery, li){
    var inModal = !!root.closest('quick-add-modal');
    if (inModal) {
      var ul = li.parentElement;
      if (ul.firstElementChild !== li) ul.insertBefore(li, ul.firstElementChild);
      ul.querySelectorAll('li[data-media-id]').forEach(function(x){ x.classList.remove('is-active'); });
      li.classList.add('is-active'); ul.scrollLeft = 0;
    } else if (typeof gallery.setActiveMedia === 'function') {
      var y0 = window.scrollY;
      gallery.setActiveMedia(li.dataset.mediaId, false);
      // Dawn scrolls the window up to the gallery; keep the shopper where they clicked
      var keep = function(){ if (Math.abs(window.scrollY - y0) > 2) window.scrollTo({top:y0, behavior:'instant'}); };
      [0, 60, 250, 600].forEach(function(t){ setTimeout(keep, t); });
    } else {
      li.scrollIntoView({block:'nearest', inline:'start'});
    }
    /* thumbnail active state */
    var mid = li.dataset.mediaId;
    gallery.querySelectorAll('[data-target]').forEach(function(t){
      var on = t.dataset.target === mid;
      t.classList.toggle('is-active', on);
      var btn = t.querySelector('button'); if (btn) { if (on) btn.setAttribute('aria-current','true'); else btn.removeAttribute('aria-current'); }
    });
  }
  function show(root, v){
    var gallery = root.querySelector('media-gallery'); if (!gallery) return;
    remember(gallery);
    restore(gallery); /* always start from the original images so switching back works */
    var fm = v && v.featured_media; if (!fm || !fm.id) return;
    var li = gallery.querySelector('li[data-media-id$="-' + fm.id + '"]');
    if (li) { activate(root, gallery, li); return; }
    /* variant media hidden from gallery: swap the first image (original is kept for restore) */
    var src = (fm.preview_image && fm.preview_image.src) || fm.src; if (!src) return;
    var firstLi = gallery.querySelector('li[data-media-id]'); var img = firstImg(gallery); if (!img || !firstLi) return;
    activate(root, gallery, firstLi);
    var base = src.split('?')[0];
    img.removeAttribute('srcset'); img.setAttribute('src', base + '?width=1100'); img.dataset.llSwapped = '1';
  }
  function update(root, id){
    id = id || currentId(root); if (!id) return;
    if (root.__llLast === id) return; root.__llLast = id;
    var v = findVariant(inlineVariants(root), id);
    if (v && v.featured_media) { show(root, v); return; }
    productJson(root).then(function(p){ if (p) show(root, findVariant(p.variants, id)); });
  }
  function rootOf(el){ return el && el.closest && el.closest('[id^="MainProduct-"], quick-add-modal [id^="QuickAddInfo-"]'); }
  document.addEventListener('change', function(e){
    var r = rootOf(e.target); if (r) setTimeout(function(){ r.__llLast = null; update(r); }, 60);
  }, true);
  document.addEventListener('variant:changed', function(e){
    var id = e.detail && (e.detail.variantId || (e.detail.variant && e.detail.variant.id));
    var r = rootOf(e.target) || document.querySelector('[id^="MainProduct-"]');
    if (r && id) update(r, String(id));
  });
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    try { subscribe(PUB_SUB_EVENTS.variantChange, function(ev){ var d=ev&&ev.data; if(d&&d.variant){ var r=document.querySelector('[id^="'+(d.sectionId&&d.sectionId.indexOf('quickadd')===0?'QuickAddInfo-':'MainProduct-')+'"]'); if(r) update(r,String(d.variant.id)); } }); } catch(e){}
  }
  /* catches app pickers (Kaching, #litlamp-lls) that set the hidden id input directly */
  roots().forEach(function(r){ var g=r.querySelector('media-gallery'); if(g) remember(g); });
  setInterval(function(){ roots().forEach(function(r){ if (r.offsetParent !== null || r.closest('quick-add-modal[open]')) update(r); }); }, 400);
})();
